import { render, staticRenderFns } from "./RevenueShareSearch.vue?vue&type=template&id=6c6558a0&scoped=true&"
import script from "./RevenueShareSearch.vue?vue&type=script&lang=js&"
export * from "./RevenueShareSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6558a0",
  null
  
)

export default component.exports